import { render, staticRenderFns } from "./download-track-collection.vue?vue&type=template&id=228633cb"
import script from "./download-track-collection.vue?vue&type=script&lang=js"
export * from "./download-track-collection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports